import { getAllContestsAPI } from '@/services/admin';
export async function getAllContests(yearId: string, limit: string, page: string, search: string) {
  try {
    const contests = await getAllContestsAPI(yearId, limit, page, search);
    return contests;
  } catch (error) {
    console.log(error);
    throw "Cant't get contests";
  }
}
